import React from "react";
import PropTypes from "prop-types";

const ThankYouMessage = ({ thankYouMessage, onChangeCallback }) => (
  <div>
    <h2>Thank you Message</h2>
    <ul className="help">
      <li>Customer will see this message after filling out the Order Form</li>
      <li>Use this text to signal next steps to your Customers</li>
      <li>Leave blank for the default, generic message</li>
    </ul>
    <textarea
      name="thankYouMessage"
      id="thankYouMessage"
      cols="40"
      rows="10"
      value={thankYouMessage}
      placeholder="We have successfully created your tour. You will receive an email confirmation shortly, and your tour provider will be in contact to schedule your tour."
      onChange={event => onChangeCallback(event.target.value)}
    />
  </div>
);

ThankYouMessage.propTypes = {
  thankYouMessage: PropTypes.string,
  onChangeCallback: PropTypes.func.isRequired,
};

export default ThankYouMessage;
